import React from 'react';
import reactDom from '../../../common/react/dom/index';
import EventsContainer from '../../../components/frontend/events/EventsContainer/EventsContainer';
import SpotlightContainer from '../../../components/frontend/spotlight/SpotlightContainer';

export default function init() {
	reactDom(<EventsContainer />, 'js-react-events');
	reactDom(<SpotlightContainer />, 'js-react-spotlight');
}
